// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"hotspot-wave"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9 3H5V23H19V13","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M13 1C17.4183 1 21 4.58172 21 9M13 5C15.2091 5 17 6.79086 17 9M13 9H13.0039V9.00391H13V9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const HotspotWaveIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'hotspot-wave',
    ref,
    icon: element,
  },
));

HotspotWaveIcon.displayName = 'HotspotWaveIcon';

export default HotspotWaveIcon;
